import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';



const Project = ({projects}) => {

  useEffect(()=>{
    window.scrollTo(0, 0);
  },[])

  const navigate = useNavigate();

  const {id} = useParams();

  const [project, setProject] = useState();
  const [projectLen, setProjectsLen] = useState(0)

  useEffect(()=>{
    window.scrollTo(0, 0);
    setProject(projects[id])
    setProjectsLen(projects.length)
  },[])

  useEffect(()=>{
    setProject(projects[id])
    setProjectsLen(projects.length)
  }, [id])


  return (
    <div>
      {project? 
          <div className='min-h-[100vh] w-full px-6 md:px-12 lg:px-32 pt-[18vh] md:pt-[20vh] flex flex-col gap-4 items-center lg:pt-28 pb-12'>

            <div className='w-[80%]'>
              <h1 className='w-full text-center text-2xl md:text-4xl font-mosk300 flex flex-col md:flex-row md:gap-1 justify-center' ><span className='text-4xl font-mosk600' > {project.title}</span></h1>
            </div>

            <div className='w-full flex flex-col md:flex-row justify-between items-start py-4 md:py-0' >
                <div className='flex gap-1 font-mosk600 pb-4'>
                  <p className='cursor-pointer hidden md:block hover:font-mosk600' onClick={()=> navigate('/projects')}>Projects</p>
                  <p  className='hidden md:block'>/</p>
                  <p className=' cursor-pointer hover:font-mosk600' onClick={()=> navigate('/project-photos')}>Project Photos</p>
                  <p >/</p>
                  <p>{project.title}</p>
                </div>

                {projects[`${parseInt(id)+1}`]?
                <div onClick={()=> navigate(`/project/${parseInt(id)+1}`)} className='flex items-center gap-1 pointer-cursor'>
                  <p>Next: </p>
                  <p className='hover:font-mosk600' >{projects[`${parseInt(id)+1}`].title}</p>
                </div>
                :
                  <div></div>
                }
                
            </div>

            <div className='grid grid-cols-1 md:grid-cols-2 gap-8' >
              {
                project.imgs.map((image, index)=>{
                  return(
                    // <img key={index} className='max-h-[70vh] md:h-[20vh] lg:h-[50vh] w-full rounded-lg' src={image} alt="" />
                    <div data-aos="fade-up" data-aos-duration={800 + ((index%2) * 150)} className='h-[30vh] md:h-[20vh] hover:drop-shadow-lg  lg:h-[50vh] w-[90vw] md:w-[40vw] lg:w-[35vw] rounded-lg bg-center bg-cover' style={{backgroundImage: `url(${image})`}} ></div>
                  )
                })
              }
            </div>
        </div>

      :
        <div>loading....</div>
      }
        
</div>
  )
}

export default Project
